<template>

    <div class="col-sm-12 bg-lightest border-light cardHeight2 d-flex flex-column radius-normal">
        <div class="mb-1">
            <div class="text-center darker font-weight-600 mt-4 fs-large">
                {{title}}
            </div>
            <div class="dark text-center fs-small">
                {{subTitle}}
            </div>
        </div>
        <div class="text-center w-100 mb-5 infoHolder">
            <graph class="graph w-100" :height="230" :chartData="graphData" ></graph>
        </div>
    </div>

</template>

<script>
    import graph from '@/tools/charts/reports/dateSummary'

    export default {
        data: function(){
            return {
            }
        },
        computed:{
            graphData: function(){
                var chartData = {
                    labels: this.graphLabels,
                    datasets: [
                        {
                            data: this.graphValues,
                            backgroundColor: '#00a9f0'
                        }
                    ]
                };

                return chartData;
            }
        },
        props:[
            'title',
            'subTitle',
            'graphLabels',
            'graphValues'
        ],
        components:{
            graph
        }
    }
</script>

<style scoped lang="scss">

    .cardHeight1{
        height: 230px;
    }

    .fs-superBig{
        font-size: 2.5rem;
    }

</style>



// WEBPACK FOOTER //
// cardGraphSummary.vue?3125bdb1